import { render, staticRenderFns } from "./userConfig.vue?vue&type=template&id=0c791966&scoped=true&lang=pug&"
import script from "./userConfig.vue?vue&type=script&lang=js&"
export * from "./userConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c791966",
  null
  
)

export default component.exports